import type { CSSProperties } from 'react';

import { cn } from '@/utils/cn';

const PALETTE = [
  '#1F47AB', '#0E8E8E', '#0F9D6B', '#B45309', '#C0392B',
  '#7C3AED', '#DB2777', '#0891B2', '#65A30D', '#EA580C',
];

export function colorFromKey(key: string | number): string {
  const s = String(key);
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}

export function initialsOf(first?: string | null, last?: string | null): string {
  const a = first?.trim()?.[0] ?? '';
  const b = last?.trim()?.[0] ?? '';
  return (a + b).toUpperCase() || '?';
}

interface AvatarProps {
  initials: string;
  colorKey?: string | number;
  color?: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export function Avatar({ initials, colorKey, color, size = 26, className, style }: AvatarProps) {
  const bg = color ?? (colorKey !== undefined ? colorFromKey(colorKey) : undefined);
  const fontSize = Math.max(10, Math.round(size * 0.4));
  return (
    <span
      className={cn('ds-avatar', className)}
      style={{
        width: size,
        height: size,
        fontSize,
        background: bg,
        ...style,
      }}
    >
      {initials}
    </span>
  );
}
